import React, {useState} from "react";
import {Button,  Input, Checkbox, Form, Col, Row} from "antd";
import {addTaskLink, editTaskLink} from "../../../api";
import TextArea from "antd/es/input/TextArea";

function AddEditRoleDialog ({ action, link, onClose, setLinks}) {
    const [form] = Form.useForm();
    const [linkURL, setLinkURL] = useState(link?.link);
    const [linkTitle, setLinkTitle] = useState(link?.linkTitle);
    const [linkDisable, setLinkDisable] = useState(link!==null ? link.disableFlag : 'N');
    const [docId, setDocId] = useState(link?.docId);

    const onURLChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setLinkURL(value);
        }
    }
    const onDocIdChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setDocId(value);
        }
    }
    const onTitleChange = (e) => {
        const { value } = e.target;
        if (value !== null || value !== '') {
            setLinkTitle(value);
        }
    }
    const onSubmit = async (values) => {
        if(action==='Add') {
            let newLink = {linkTitle: linkTitle, link: linkURL, docId: docId, disableFlag:'N'};
            let response = await addTaskLink(newLink);
            if(response.status === 'SUCCESS')
                setLinks(response.data);
        }
        else
        {
            let editLink = {...link, linkTitle: linkTitle, link: linkURL, docId: docId, disableFlag: linkDisable};
            let response = await editTaskLink(editLink);
            if(response.status === 'SUCCESS')
                setLinks(response.data);
        }
        onClose();
    }
    return (
        <div className='react-confirm-alert-body'>
            <h4>{action=='Add' ? 'Add New Task Link': ('Edit Link: '+linkTitle)}</h4>
            <section>
                <Form
                    form={form}
                    style={{ padding: '1rem 1rem' }}
                    onFinish={(values) => onSubmit(values)}
                >
                    <div style={{ top: 15, position: 'relative' }}>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='Link Title'
                                    name='linkTitle'
                                    initialValue={linkTitle}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter title!'
                                        }                                ]}
                                >
                                    <Col>
                                        <TextArea
                                            id='linkTitle'
                                            size='small'
                                            value={linkTitle}
                                            placeholder='Link Title'
                                            onChange={onTitleChange}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='link URL'
                                    name='linkURL'
                                    initialValue={linkURL}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter URL!'
                                        }                                ]}
                                >
                                    <Col>
                                        <Input
                                            id='linkURL'
                                            size='small'
                                            value={linkURL}
                                            placeholder='Link URL'
                                            onChange={onURLChange}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='Document Id'
                                    name='docId'
                                    initialValue={docId}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter Document Id!'
                                        }                                ]}
                                >
                                    <Col>
                                        <Input
                                            id='docId'
                                            size='small'
                                            value={docId}
                                            placeholder='Document Id'
                                            onChange={onDocIdChange}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row justify='center' align='middle'>
                            <Col sm={24} style={{ alignItems: 'end' }}>
                                <Form.Item
                                    label='Disable?'
                                    name='disable'
                                    initialValue={linkDisable==='Y'}
                                    labelCol={{ span: 5 }}
                                    style={{fontWeight:'bolder'}}
                                >
                                    <Col>
                                        <Checkbox
                                            name='selected'
                                            checked={linkDisable==='Y'}
                                            onChange={(e) => {
                                                let value = e.target.checked ? 'Y' : 'N';
                                                setLinkDisable(value);
                                            }}
                                        />
                                    </Col>
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Button
                            className='btn btn-primary start-5'
                            type='primary' htmlType='submit'
                        >
                            Save Changes
                        </Button>
                        <Button className='btn btn-primary start-5' type='primary' onClick={onClose}>
                            Cancel
                        </Button>{' '}
                    </div>
                </Form>
            </section>
        </div>
  );
}

export default AddEditRoleDialog;